import graphql__fb22cab564f83beccfe7 from "./__generated__/ResendTwoFactorCodeMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__fb22cab564f83beccfe7;

function resendTwoFactorCode() {
  return new Promise((resolve, reject) => {
    commitMutation(appRelayEnvironment, {
      mutation,
      variables: {},
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(response);
        }
      },
      onError: error => reject(error)
    });
  });
}

export { resendTwoFactorCode };
